// extracted by mini-css-extract-plugin
module.exports = {"folderContainer":"ProjectRenderer_folderContainer__JGpz4","projectContainer":"ProjectRenderer_projectContainer__1a6P4","sidebarContainer":"ProjectRenderer_sidebarContainer__1dSWJ"};